import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { desktopSidebarTabs } from "../desktopTabs";
import { TERMS_AND_CONTACT_ARR } from "../../../../../constant/dummyData";
import { GA_EVENTS, GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { ScreenTypes } from "../../../../../enums";
import { INITIAL_BREADCRUMBS_LIST } from "../../../../../constant/bookingInProgressConstant";
import { consoleLog } from "../../../../../utils/consoleLog/consoleLog";
import styles from "../tab.module.scss";
import { DialogSelected, ENVIRONMENT_TYPE } from "../../../../../constant/common";
import { environment } from "../../../../../constant/environment";
import { Dispatch, SetStateAction } from "react";

interface DesktopTabsProps {
  value: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  currentTripData: any;
  userInfo: any;
  showGetHelpOptions: boolean;
  setShowGetHelpOptions: Dispatch<SetStateAction<boolean>>;
  setShowZoho: Dispatch<SetStateAction<boolean>>;
  setLoginCreateAccountState: (state: any) => void;
  setScreen: (screen: string) => void;
  setMyTripActiveTab: (tab: string) => void;
  resetBookingValues: () => void;
  setFirstScreen: (screen: string) => void;
  sendPixelEvent: (event: string, data: any) => void;
  handleBook: () => void;
  setActiveBreadCrumbs: (crumbs: any) => void;
  setHotelData: (data: any) => void;
  setFlightData: (data: any) => void;
  setHideDetails: (hide: boolean) => void;
  setValue: Dispatch<SetStateAction<number>>;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const DesktopTabs = ({
  value,
  handleChange,
  currentTripData,
  userInfo,
  showGetHelpOptions,
  setShowGetHelpOptions,
  setShowZoho,
  setLoginCreateAccountState,
  setScreen,
  setMyTripActiveTab,
  resetBookingValues,
  setFirstScreen,
  sendPixelEvent,
  handleBook,
  setActiveBreadCrumbs,
  setHotelData,
  setFlightData,
  setHideDetails,
  setValue,
}: DesktopTabsProps) => {
  return (
    <Tabs
      orientation={"vertical"}
      value={value}
      onChange={handleChange}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "none",
        "& .MuiTab-root": {
          color: "#8F8F8F",
          fontSize: 11,
          fontFamily: "var(--brand-font-body)",
          fontWeight: "600",
          marginTop: "0px",
          paddingTop: "8px",
          paddingBottom: "8px",
          textAlign: "left",
        },
        "& .Mui-selected": {
          color: "#8F8F8F !important",
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      {desktopSidebarTabs.map((data, idx) => {
        if (!(JSON.stringify(currentTripData) === "{}" && data?.title === "Current Trip"))
          return (
            <Tab
              key={idx}
              disableTouchRipple
              icon={
                <img
                  src={data?.icon}
                  alt=""
                  style={{
                    width: "15px",
                    transform: "translateY(-1px)",
                  }}
                />
              }
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setScreen("");
                setMyTripActiveTab("UPCOMING");
                resetBookingValues();
                if (data.title === "Current Trip") {
                  triggerGAEvent(GA_LABEL_ENUMS.Current_trips_click);
                  setFirstScreen(ScreenTypes.CurrentTrip);
                }
                if (data.title === "My Trips") {
                  triggerGAEvent(GA_LABEL_ENUMS.My_trips_click);
                  setFirstScreen(ScreenTypes.MyTrips);
                }
                if (data.title === "For you") {
                  triggerGAEvent(GA_LABEL_ENUMS.My_trips_click);
                  setFirstScreen(ScreenTypes.ForYou);
                }
                if (data.title === "Shop travel") {
                  triggerGAEvent(GA_LABEL_ENUMS.book_without_itinerary_click);
                  sendPixelEvent("interactedWithChat", {
                    event: GA_EVENTS[GA_LABEL_ENUMS.book_without_itinerary_click]?.label,
                  });
                  sendPixelEvent("startChat", {
                    event: GA_EVENTS[GA_LABEL_ENUMS.book_without_itinerary_click]?.label,
                  });
                  consoleLog(["PIXEL EVENT SESSION START"]);
                  handleBook();
                  setActiveBreadCrumbs(INITIAL_BREADCRUMBS_LIST[0]);
                  setHotelData(null);
                  setFlightData(null);
                  setScreen("");
                  setTimeout(() => {
                    setScreen(ScreenTypes.newBooking);
                    setHideDetails(false);
                  }, 500);
                }
                if (data.title === "preferences") setFirstScreen(ScreenTypes.Preferences);
                if (data.title === "HELP") setFirstScreen(ScreenTypes.help);
                setValue(idx);
              }}
              iconPosition="start"
              label={data.title}
              {...a11yProps(idx)}
              sx={{
                mx: "20px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                height: "20px !important",
                padding: 0,
                marginTop: "40px",
                minHeight: "35px",
                visibility:
                  data.title !== "Current Trip"
                    ? "visible"
                    : JSON.stringify(currentTripData) === "{}"
                      ? "hidden"
                      : "visible",
              }}
            />
          );
        return null;
      })}
      <div>
        {TERMS_AND_CONTACT_ARR.filter((item) => {
          if (userInfo?.loggedIn) {
            return true;
          }
          if (!userInfo?.loggedIn && item.id === 1) return false;
          return true;
        }).map((item) => {
          return (
            <div key={item.id}>
              <a
                style={{
                  textDecoration: "none",
                  color: "#8F8F8F !important",
                }}
                href={item.link}
                rel="noreferrer"
                target={"_self"}
                onClick={() => {
                  if (item.title === "Get help") {
                    triggerGAEvent(GA_LABEL_ENUMS.sidebar_get_help);
                    setShowGetHelpOptions(!showGetHelpOptions);
                  } else {
                    if (item?.title === "Terms of Service") triggerGAEvent(GA_LABEL_ENUMS.Terms_of_service_click);
                    if (item?.title === "Privacy Policy") triggerGAEvent(GA_LABEL_ENUMS.Privacy_polcy_click);
                  }
                }}
              >
                <Tab
                  disableTouchRipple
                  label={item.title}
                  sx={{
                    ml: "3px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    fontWeight: "900",
                    opacity: 1,
                    minHeight: "10px",
                  }}
                />
              </a>
              {item.id === 0 && showGetHelpOptions && (
                <div className={styles.getHelpCard}>
                  <p
                    className={styles.getHelp}
                    onClick={() => {
                      triggerGAEvent(GA_LABEL_ENUMS.sidebar_contact_us);
                      setLoginCreateAccountState({
                        flag: true,
                        page: DialogSelected.GET_HELP,
                      });
                      setShowGetHelpOptions(false);
                    }}
                  >
                    Contact us
                  </p>

                  {userInfo.loggedIn && environment !== ENVIRONMENT_TYPE.PRODUCTION && (
                    <p
                      className={styles.getHelp}
                      onClick={() => {
                        setShowZoho(true);
                        triggerGAEvent(GA_LABEL_ENUMS.sidebar_chat_with_us);
                      }}
                    >
                      Chat with us
                    </p>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Tab
        disableTouchRipple
        label="HISTORY"
        sx={{
          mb: "15px",
          ml: "3px",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          minHeight: "10px",
        }}
        onClick={() => {
          setValue(desktopSidebarTabs.length);
        }}
      />
    </Tabs>
  );
};
